import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import UserTimeFormat from '../../components/user-time-format/connected';
import UserDateFormat from '../../components/user-date-format/index';

import messages from './messages';

export const ScanItemVerificationTooltip = ({ children, userName, verifiedUtc, className }) => {
  const verificationTooltipMessage = userName ? (
    <FormattedMessage {...messages.verifiedBy} values={{ userName }} />
  ) : (
    <FormattedMessage {...messages.verified} />
  );
  return (
    <Tooltip position='bottom'>
      {children}
      <TooltipContent>
        <div className={className}>
          <span>{verificationTooltipMessage}</span>
          <UserDateFormat value={verifiedUtc} />
          &nbsp;
          <UserTimeFormat value={verifiedUtc} />
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

ScanItemVerificationTooltip.propTypes = {
  verifiedUtc: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  userName: PropTypes.string,
  className: PropTypes.string,
};
